import apiUtils from '@elab/core/utils/apiUtils';

import HTTPClient from '../../utils/HTTPClient';
import cartApi from '../cart/api';
import logger from '../../utils/logger';

const getApiService = (userId, newAPI = false) => {
    // Future scope: we should remove this flag once all other bu adopt to this new approach
    let baseURL = `${apiUtils.getBaseUri()}`;
    baseURL += newAPI ? '/common' : '';
    return `${baseURL}/users/${userId || 'anonymous'}`;
};

const getMethods = async (userId, cartId, isEgiftCardCartActive = false) => {
    if (process.env.NODE_ENV === 'production') {
        const uri = `${cartApi.getCurrentCartApiService(
            userId,
            cartId,
            isEgiftCardCartActive,
        )}/paymentmodes?fields=FULL`;
        const response = await HTTPClient().get(uri);

        if (!response.ok) {
            return response;
        }
        return await response.json();
    }
    if (process.env.NODE_ENV === 'development') {
        return { paymentModes: require('./mock.methods').paymentMethods };
    }
};

const getSavedTokenCards = async (userId, cartId, isEgiftCardCartActive = false) => {
    if (process.env.NODE_ENV === 'production') {
        const uri = `${cartApi.getCurrentCartApiService(
            userId,
            cartId,
            isEgiftCardCartActive,
        )}/paymentSubscriptions?fields=FULL`;
        const response = await HTTPClient().get(uri);

        if (!response.ok) {
            return response;
        }
        return await response.json();
    }
    if (process.env.NODE_ENV === 'development') {
        return { paymentModes: require('./mock.methods').default };
    }
};

const fetchMonetaWebIFrameUrl = async userId => {
    const uri = `${apiUtils.getBaseUri()}/users/${userId}/paymentdetails/getPaymentInfosIframeURL`;
    let response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return await response.json();
};
const setPaymentMethod = async (userId, cartId, paymentModeId, isEgiftCardCartActive) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
        isEgiftCardCartActive,
    )}/paymentmode?paymentModeId=${paymentModeId}`;
    const response = await HTTPClient().putJson(uri);
    if (!response.ok) {
        throw new Error('Error in setting payment method');
    }
    return await response;
};

const deletePaymentMethod = async (userId, cartId, isEgiftCardCartActive) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
        isEgiftCardCartActive,
    )}/paymentmode`;
    const response = await HTTPClient().delete(uri);
    if (!response.ok) {
        throw new Error('Error in deleting payment method');
    }
    return await response;
};

const getPaymentSession = async (userId, cartId, paymentModeId, isEgiftCardCartActive) => {
    const uri = `${cartApi.getCurrentCartApiService(
        userId,
        cartId,
        isEgiftCardCartActive,
    )}/payment/${paymentModeId}/session`;
    const response = await HTTPClient().post(uri);
    if (!response.ok) {
        throw new Error('Error in getting payment session');
    }
    return await response.json();
};

const getPayWithLoyaltyPointsMethodExtraInfo = async (userId, cartId) => {
    if (process.env.NODE_ENV === 'production') {
        const uri = `${cartApi.getCurrentCartApiService(
            userId,
            cartId,
        )}/paymentmodes/paywithpoints`;
        const response = await HTTPClient().get(uri);

        if (!response.ok) {
            logger.error('Error in getting extended information about payWithPoints paymentmode');
        }

        const responseData = await response.json();
        responseData.serverResponseStatus = response.status;

        return responseData;
    }
    if (process.env.NODE_ENV === 'development') {
        return require('./mock.paywithpoints.method').default;
    }
};

const payWithPoints = async (userId, cartId, doPay, points) => {
    if (process.env.NODE_ENV === 'production') {
        const uri = `${cartApi.getCurrentCartApiService(userId, cartId)}/paywithpoints`;
        let response;
        if (doPay) {
            response = await HTTPClient().putJson(`${uri}?points=${points}`);
        } else {
            response = await HTTPClient().delete(uri);
        }
        if (!response.ok) {
            throw new Error('Error in paying with loyalty points');
        }
        return await response;
    }
};

const placeOrder = async (userId, cartId, shouldSubscribe, body, newAPI, isDesktop) => {
    const uri = `${getApiService(userId, newAPI)}/orders?cartId=${cartId}${
        shouldSubscribe ? '&newsletterSubscription=true' : ''
    }&isDesktop=${isDesktop}`;

    const response = await HTTPClient().postJson(uri, body);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return await response.json();
};

const getPaymentStatus = async (OrderId, sessionId) => {
    const uri = `/checkout/payment/KLARNA/return?orderId=${OrderId}&sessionId=${sessionId}`;

    const response = await HTTPClient().get(uri);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return await response;
};

const fetchIFrameUrl = async (body, userId, cartId) => {
    const uri = `${getApiService(userId)}/carts/${cartId}/sop/form`;
    const response = await HTTPClient().postJson(uri, body);
    if (!response.ok) {
        throw {
            json: await response.json(),
            status: response.status,
            message: response.message,
        };
    }
    return await response.json();
};

const removeCard = async (userId, cardId) => {
    const uri = `${apiUtils.getBaseUri()}/users/${userId}/paymentdetails/${cardId}`;
    let response = await HTTPClient().deleteJson(uri);
    return response;
};

const getGiftCardMethods = async () => {
    if (process.env.NODE_ENV === 'production') {
        const uri = `${apiUtils.getBaseUri()}/egifcards/configurations`;
        const response = await HTTPClient().get(uri);

        if (!response.ok) {
            throw new Error(`Unable to get giftCard payment methods (${response.status})`);
        }
        return await response.json();
    }
    if (process.env.NODE_ENV === 'development') {
        return { paymentModes: require('./mock.methods').giftCardMethods };
    }
};

export default {
    getMethods,
    getSavedTokenCards,
    fetchMonetaWebIFrameUrl,
    fetchIFrameUrl,
    placeOrder,
    setPaymentMethod,
    deletePaymentMethod,
    getPayWithLoyaltyPointsMethodExtraInfo,
    payWithPoints,
    removeCard,
    getGiftCardMethods,
    getPaymentSession,
    getPaymentStatus,
};
